export default __webpack_public_path__ + "static/media/agent.74013753.svg";